import { DialogResult } from './dialog-result.model';

export class DialogModal {
  public headerText: string;
  public messageText: string;
  public yesText: string;
  public noText: string;
  public cancelText: string;
  public okText: string;
  public show: boolean;
  public showCancel: boolean;
  public showAlert: boolean;
  public yesFunction: Function;
  public noFunction: Function;
  public confirmPromise: () => Promise<boolean>;
  public dialogId: string;
  public dialogResult: DialogResult;
  public dialogValue: any;
  public isWaitIndicator: boolean;
  public isErrorDialog: boolean;
  public constructor() {
    this.headerText = '';
    this.messageText = '';
    this.yesText = '';
    this.noText = '';
    this.cancelText = '';
    this.okText = '';
    this.show = false;
    this.showCancel = true;
    this.showAlert = false;
    this.yesFunction = () => {};
    this.noFunction = () => {};
    this.dialogId = Math.random()
      .toString(36)
      .slice(2);
    this.dialogResult = DialogResult.NotSet;
    this.dialogValue = null;
    this.isWaitIndicator = false;
    this.isErrorDialog = false;
  }
}
